import { createRoot } from 'react-dom/client';
import App from '@calendar/components/calendar-app';

const container = document.getElementById('calendar');

if (container) {
  container.classList.add('app--calendar');
  const root = createRoot(container);
  root.render(<App />);
}
